export default __webpack_public_path__ + "static/media/cream.d0b2eec8.png";